'use client';

import { useTracking } from './tracking-provider';
import { useEffect } from 'react';

export interface TrackPageViewProps {
  eventName?: string;
}

// Sends a pageview event to the tracker once, when the component mounts.
export default function TrackPageView({ eventName }: TrackPageViewProps) {
  const tracker = useTracking();
  useEffect(() => {
    const event = eventName || 'pageview';
    const properties: { url?: string } = {};
    if (typeof window !== 'undefined') {
      properties.url = window.location?.pathname;
    }
    tracker.trackEvent(event, properties);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
